/**
 * Rules sections, declared once so the Rules page and the command palette
 * agree. Content stays in pages/Rules.jsx; this is just the index.
 */
export const RULES_MENU = [
  { key: 'home', label: 'Home', icon: <i className="fa fa-home" /> },
  { key: 'tickets', label: 'Tickets', icon: <i className="fa fa-ticket-alt" /> },
  { key: 'chat', label: 'Chat Conduct', icon: <i className="fa fa-comments" /> },
  { key: 'factions', label: 'Factions', icon: <i className="fa fa-comments" /> },
  { key: 'misc', label: 'Misc. Rules', icon: <i className="fa fa-comments" /> },
  { key: 'disclaimer', label: 'Disclaimer', icon: <i className="fa fa-comments" /> },
];

/** Query parameter the Rules page reads to open a section directly. */
export const RULES_SECTION_PARAM = 'section';
